import _ from 'lodash';
import {Question} from 'main/stores/performance/questions';
import { makeAutoObservable } from 'mobx';

export default class UiState {
  constructor() {
    makeAutoObservable(this);
  }

  moveQuestion(cycle, dragIndex, hoverIndex) {
    const dragQuestion = cycle.orderedQuestions[dragIndex - 1];
    const hoverQuestion = cycle.orderedQuestions[hoverIndex - 1];

    dragQuestion.order = hoverIndex;
    hoverQuestion.order = dragIndex;
  }

  addQuestion(cycle) {
    cycle.questions.push(new Question({
      order: cycle.orderedQuestions.length + 1,
      text: ''
    }));
  }

  deleteQuestion(questions, question) {
    _.remove(questions, question);

    const laterQuestions = _.filter(questions, q => q.order > question.order);
    for (const q of laterQuestions) {
      q.order -= 1;
    }
  }
}
